import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import WidthContainer from '../../../components/WidthContainer'

const phoneBreakpoint = '@media only screen and (max-width: 800px)'

const RootContainer = styled(WidthContainer)`
`

const Day = styled.div`
	position: relative;
	padding-bottom: 6rem;
`

const Circle = styled.div`
	position: absolute;
	top: .35rem;
	left: 0;
	border: 1px solid #939393;
	width: 1.3rem;
	height: 1.3rem;
	border-radius: 100%;
`

const Line = styled.div`
	position: absolute;
	width: 1px;
	background: #D8D8D8;
	top: 2rem;
	left: 0.65rem;
	bottom: 1rem; 
`

const DayTitle = styled.h2`
	margin-bottom: 2.5rem;
	margin-left: 2rem;
`

const Row = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap; 
`

const Date = styled.div`
	${props => props.smaller && `
		font-size: ${props.theme.fontSizes.small}
	`}
`

const Programs = styled.div`
	display: flex;
	margin: -1rem;
	> * {
		margin: 1rem 3rem;
	}
	
	${phoneBreakpoint} {
		flex-direction: column;
	}
`

const Program = styled.div`
	flex: 1;

`

const ProgramTitle = styled.div`
	font-weight: ${props => props.theme.fontWeights.bold};
	font-size: ${props => props.theme.fontSizes.big20};
	margin-bottom: 1rem;
`

const Point = styled.div`
	background: ${props => props.type === 'break' ? 'white' : props.theme.colors.grayBack};
	padding: 1.5rem 1.6rem;
	position: relative;
	
	&.typeProgram+.typeProgram{
		&::before {
			position: absolute;
			top: 0;
			left: 1.5rem;
			right: 1.5rem;
			content: '';
			height: 1px;
			background: #EAEAEA;
		}
	}
`

const PointName = styled.div`
	font-weight: ${props => props.theme.fontWeights.bold};
`

const PointDescription = styled.div`
	margin-top: 1rem;
	max-width: 19rem;
`

const ProgramSection = ({className, data}) => <RootContainer className={className}>
	{data.map((day, i) => <Day key={i}>
		<Circle/>
		{i < data.length - 1 && <Line/>}
		<DayTitle>Day {i + 1}</DayTitle>
		<Programs>
			{day.programs.slice(0, 2).map(program => <Program key={program.name}>
				<Row>
					<ProgramTitle>{program.name}</ProgramTitle>
					<Date>{program.date}</Date>
				</Row>
				{program.points.map(point => <Point
					className={point.type === 'program' ? 'typeProgram' : 'typeBreak'}
					type={point.type}
					key={point.name}>
					<Row>
						<PointName>{point.name}</PointName>
						<Date smaller>{point.timeRange}</Date>
					</Row>
					{point.description && <PointDescription>{point.description}</PointDescription>}
				</Point>)}
			</Program>)}
		</Programs>
	</Day>)}
</RootContainer>

ProgramSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.arrayOf(PropTypes.shape({
		programs: PropTypes.arrayOf(PropTypes.shape({
			name: PropTypes.string.isRequired,
			date: PropTypes.string.isRequired,
			points: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				timeRange: PropTypes.string.isRequired,
				description: PropTypes.string.isRequired,
				type: PropTypes.oneOf(['program', 'break']).isRequired,
			})).isRequired,
		}).isRequired).isRequired,
	}).isRequired).isRequired,
}

ProgramSection.defaultProps = {
	className: '',
}

export default ProgramSection
